import { render } from "./UsernameAvatar.vue?vue&type=template&id=ae16f9f2&scoped=true"
import script from "./UsernameAvatar.vue?vue&type=script&lang=js"
export * from "./UsernameAvatar.vue?vue&type=script&lang=js"

import "./UsernameAvatar.vue?vue&type=style&index=0&id=ae16f9f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae16f9f2"]])

export default __exports__